import { render, staticRenderFns } from "./FilterNode.vue?vue&type=template&id=242b575d&scoped=true"
import script from "./FilterNode.vue?vue&type=script&lang=ts"
export * from "./FilterNode.vue?vue&type=script&lang=ts"
import style0 from "./FilterNode.vue?vue&type=style&index=0&id=242b575d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242b575d",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/filter.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Ffilter%2FFilterNode.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports